import { useEffect, useState } from "react";
import { FaCog } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import Declaration from "./Declaration";
import { toast } from "react-toastify";
import AllergenSelection from "./Allergens";
import axios from "axios";
import Loader from "../../Services/Loader";

const DeclarationEdit = ({ ing_item_code, rm_code }) => {
    const [columnValues, setColumnValues] = useState({
        ing_item_code: '',
        rm_code: '',
        vegetarian: '',
        vegan: '',
        non_gmo: '',
        classification: '',
        gluten_status: '',
        bse_tse: '',
        // declared_allergen: '',
        // allergen_fermentation: '',
        residual_solvent: '',
        wada_compliance: '',
        eto_treated: '',
        irradiated: '',
        sewage_sludge_treated: '',
        pesticide: '',
        aflatoxin: '',
        preservative: '',
        antibiotic: '',
        gras: '',
        prop65_complaint: '',
    });

    const [allergens, setAllergens] = useState({
        wheat: '',
        eggs: '',
        crustaceans_shell_fish: '',
        fish: '',
        milk: '',
        tree_nuts: '',
        peanuts: '',
        soy: '',
        sesame_seeds: '',
        celery: '',
        barley_oats_rye_spelt: '',
        orange_kiwi_peaches_apples: '',
        mushrooms: '',
        mustard: '',
        lupin: '',
        molluscs: '',
        sulfur: ''
    });

    const [error, setError] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown visibility
    const [currentStep, setCurrentStep] = useState(1); // To track the pagination steps
    const { ing_item_code: ingr_code, rm_code: rm_Code } = useParams();
  

    const fetchDetails = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URI}/elixir/fetch_declaration`, {
                params: {
                    ing_item_code: ingr_code,
                    rm_code: rm_Code
                },
                headers: {
                    "Content-Type": 'application/json',
                    Accept: 'application/json'
                },
                withCredentials: true
            });

            if (response.status === 200) {
               
                if (response.data.data && response.data.data.length > 0) {
                    const data = response.data.data[0];
                  
                    // Update columnValues
                    setColumnValues((prev) => ({
                        ...prev,
                        ing_item_code: data.ing_item_code || "",
                        rm_code: data.rm_code || "",
                        vegetarian: data.vegetarian || "",
                        vegan: data.vegan || "",
                        non_gmo: data.non_gmo || "",
                        classification: data.classification || "",
                        gluten_status: data.gluten_status || "",
                        bse_tse: data.bse_tse || "",
                        residual_solvent: data.residual_solvent || "",
                        wada_compliance: data.wada_compliance || "",
                        eto_treated: data.eto_treated || "",
                        irradiated: data.irradiated || "",
                        sewage_sludge_treated: data.sewage_sludge_treated || "",
                        pesticide: data.pesticide || "",
                        aflatoxin: data.aflatoxin || "",
                        preservative: data.preservative || "",
                        antibiotic: data.antibiotic || "",
                        gras: data.gras || "",
                        prop65_complaint: data.prop65_complaint || "",
                    }));

                    // Update allergens
                    setAllergens((prev) => ({
                        ...prev,
                        wheat: data.wheat || "",
                        eggs: data.eggs || "",
                        crustaceans_shell_fish: data.crustaceans_shell_fish || "",
                        fish: data.fish || "",
                        milk: data.milk || "",
                        tree_nuts: data.tree_nuts || "",
                        peanuts: data.peanuts || "",
                        soy: data.soy || "",
                        sesame_seeds: data.sesame_seeds || "",
                        celery: data.celery || "",
                        barley_oats_rye_spelt: data.barley_oats_rye_spelt || "",
                        orange_kiwi_peaches_apples: data.orange_kiwi_peaches_apples || "",
                        mushrooms: data.mushrooms || "",
                        mustard: data.mustard || "",
                        lupin: data.lupin || "",
                        molluscs: data.molluscs || "",
                        sulfur: data.sulfur || "",
                    }));
                    setIsOpen(true);
                }
            } else {
                throw new Error("Unable to fetch details");
            }
        } catch (error) {
            setError(error.message);
        }
    }

    useEffect(() => {
        fetchDetails();
    }, [])





    const navigate = useNavigate();
    const toggleDropdown = () => {
        setDropdownOpen((prev) => !prev);
    };

    const handledb = () => {
        navigate('/database');
    };

    const previousStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const nextStep = () => {

        let isValid = true;

        if (currentStep === 1) {
            if (!columnValues.aflatoxin || !columnValues.antibiotic || !columnValues.bse_tse || !columnValues.classification || !columnValues.eto_treated || !columnValues.gluten_status || !columnValues.gras || !columnValues.irradiated || !columnValues.non_gmo || !columnValues.pesticide || !columnValues.preservative || !columnValues.prop65_complaint || !columnValues.residual_solvent || !columnValues.sewage_sludge_treated || !columnValues.vegan || !columnValues.vegetarian || !columnValues.wada_compliance) {
                isValid = false;
                toast.error("Please fill all details");
            }
            if (!isValid) {
                isValid = true;
                return
            };
        } else if (currentStep === 2) {
            if (!allergens.barley_oats_rye_spelt || !allergens.celery || !allergens.crustaceans_shell_fish || !allergens.eggs || !allergens.fish || !allergens.lupin || !allergens.milk || !allergens.molluscs || !allergens.mushrooms || !allergens.mustard || !allergens.orange_kiwi_peaches_apples || !allergens.peanuts || !allergens.sesame_seeds || !allergens.soy || !allergens.tree_nuts || !allergens.wheat) {
                isValid = false;
                toast.error("Please fill all details");
            }
            if (!isValid) {

                isValid = true;
                return
            };
        }
        setCurrentStep(currentStep + 1);
    }

    const handleSubmit = async (event) => {
        
        let isValid = true;

        
            if (!columnValues.aflatoxin || !columnValues.antibiotic || !columnValues.bse_tse || !columnValues.classification || !columnValues.eto_treated || !columnValues.gluten_status || !columnValues.gras || !columnValues.irradiated || !columnValues.non_gmo || !columnValues.pesticide || !columnValues.preservative || !columnValues.prop65_complaint || !columnValues.residual_solvent || !columnValues.sewage_sludge_treated || !columnValues.vegan || !columnValues.vegetarian || !columnValues.wada_compliance) {
                isValid = false;
                toast.error("Please fill all details");
            }
            if (!isValid) {
                isValid = true;
                return
            };
       
            if (!allergens.barley_oats_rye_spelt || !allergens.celery || !allergens.crustaceans_shell_fish || !allergens.eggs || !allergens.fish || !allergens.lupin || !allergens.milk || !allergens.molluscs || !allergens.mushrooms || !allergens.mustard || !allergens.orange_kiwi_peaches_apples || !allergens.peanuts || !allergens.sesame_seeds || !allergens.soy || !allergens.tree_nuts || !allergens.wheat) {
                isValid = false;
                toast.error("Please fill all details");
            }
            if (!isValid) {

                isValid = true;
                return
            };
        

        const payload = {
            ing_item_code: ingr_code,
            rm_code: rm_Code,
            vegetarian: columnValues.vegetarian,
            vegan: columnValues.vegan,
            non_gmo: columnValues.non_gmo,
            classification: columnValues.classification,
            gluten_status: columnValues.gluten_status,
            bse_tse: columnValues.bse_tse,
            declared_allergen: "string",
            wheat: allergens.wheat,
            eggs: allergens.eggs,
            crustaceans_shell_fish: allergens.crustaceans_shell_fish,
            fish: allergens.fish,
            milk: allergens.milk,
            tree_nuts: allergens.tree_nuts,
            peanuts: allergens.peanuts,
            soy: allergens.soy,
            sesame_seeds: allergens.sesame_seeds,
            celery: allergens.celery,
            barley_oats_rye_spelt: allergens.barley_oats_rye_spelt,
            orange_kiwi_peaches_apples: allergens.orange_kiwi_peaches_apples,
            mushrooms: allergens.mushrooms,
            mustard: allergens.mustard,
            lupin: allergens.lupin,
            molluscs: allergens.molluscs,
            sulfur: allergens.sulfur,
            allergen_fermentation: allergens.allergen_fermentation,
            residual_solvent: columnValues.residual_solvent,
            wada_compliance: columnValues.wada_compliance,
            eto_treated: columnValues.eto_treated,
            irradiated: columnValues.irradiated,
            sewage_sludge_treated: columnValues.sewage_sludge_treated,
            pesticide: columnValues.pesticide,
            aflatoxin: columnValues.aflatoxin,
            preservative: columnValues.preservative,
            antibiotic: columnValues.antibiotic,
            gras: columnValues.gras,
            prop65_complaint: columnValues.prop65_complaint,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
        }

        try {
            // Send combined data payload
            event.preventDefault();

            await axios.patch(`${process.env.REACT_APP_BASE_URI}/elixir/declaration/${ingr_code}`, payload, {
                params: {
                    rm_code: rm_Code
                },
                headers: {
                    accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });

            toast.success('Data submitted successfully!');
            setTimeout(() => {
                navigate(`/ingredient/${ingr_code}`);
            }, 3000);
            setIsOpen(false);
        } catch (error) {
            console.error("Error submitting data:", error.response?.data || error.message);

            if (error.response) {
                // Handle server response errors
                toast.error(`Server Error: ${error.response.data?.message || "Submission failed."}`);
            } else if (error.message.includes("Network Error")) {
                // Handle network errors
                toast.error("Network Error! Please check your internet connection.");
            } else {
                // Handle other errors
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    }

    const handleColumnValueChange = (event) => {
        setColumnValues((prevValues) => ({
            ...prevValues, [event.target.name]: event.target.value,
        }));
    };

    const handleAllergenChange = (event) => {
        setAllergens((prevAllergens) => ({
            ...prevAllergens, [event.target.name]: event.target.value,
        }));
    };

    if (error) {
        return <p>{error}</p>
    }

    if (!columnValues) {
        return <Loader />
    }

    return (<div className="bg-gray-900 w-full min-h-screen text-gray-200 p-8">
        <nav className="navbar bg-gray-800 text-white p-4 flex justify-between">
            <h1 className="text-2xl font-bold">Ingredient Database</h1>
            <div className="relative">
                <button
                    className="text-white font-bold py-2 px-4 rounded"
                    title="Settings"
                    onClick={toggleDropdown}
                >
                    <FaCog />
                </button>
                {dropdownOpen && (
                    <div className="absolute right-0 mt-2 bg-gray-900 text-white rounded shadow-lg p-2 w-48">
                        <ul>
                            <li
                                onClick={handledb}
                                className="py-1 cursor-pointer hover:bg-gray-700">
                                Database
                            </li>
                        </ul>
                    </div>)}
            </div>
        </nav>

        <div className="p-8 bg-gray-800 rounded-lg mt-6 space-y-6 flex flex-col">
            <div>
                <button onClick={() => { navigate(-1) }} type="button" class="bg-gray-900 mb-6 relative top left-0 text-white py-2 px-4 rounded shadow hover:bg-gray-600">Back To Ingredients</button>
            </div>
            {
                !isOpen ? (<div>
                    <Loader />
                </div>

                ) : (
                    <div>
                        <h2 className="text-xl font-bold mb-4">Step {currentStep}</h2>

                        {currentStep === 1 && (<Declaration
                            columnValues={columnValues}
                            handleColumnValueChange={handleColumnValueChange}
                            className="w-1/2"
                        />)}

                        {currentStep === 2 && (<AllergenSelection
                            allergens={allergens}
                            handleAllergenChange={handleAllergenChange}
                        />)}

                        {/* Pagination Controls */}
                        <div className="flex justify-between mt-4">
                            {currentStep > 1 && (<button
                                onClick={previousStep}
                                className="bg-gray-700 text-white px-4 py-2 rounded"
                            >
                                Previous
                            </button>)}
                            {currentStep < 2 && (<button
                                onClick={nextStep}
                                className="bg-blue-600 text-white px-4 py-2 rounded"
                            >
                                Next
                            </button>)}
                            {currentStep === 2 && (<button
                                onClick={handleSubmit}
                                className="bg-green-600 text-white px-4 py-2 rounded"
                            >
                                Submit
                            </button>)}
                        </div>
                    </div>
                )
            }



        </div>
    </div>
    )
}

export default DeclarationEdit;